import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { request } from '@/lib/api';
import {
  businessActivitySchema,
  businessesSchema,
  overviewSchema,
  usageSchema,
  type RangeDays,
} from './admin-schemas';

/* קריאות הקונסולה. השרת רושם כל צפייה ביומן הביקורת — אין כאן רענון אוטומטי. */

const base = {
  staleTime: 60_000,
  refetchOnWindowFocus: false,
  placeholderData: keepPreviousData,
} as const;

export function useOverview(days: RangeDays) {
  return useQuery({
    queryKey: ['platform-admin', 'overview', days],
    queryFn: ({ signal }) =>
      request(`/platform-admin/overview?days=${days}`, { schema: overviewSchema, signal }),
    ...base,
  });
}

export function useUsage(days: RangeDays, enabled: boolean) {
  return useQuery({
    queryKey: ['platform-admin', 'usage', days],
    queryFn: ({ signal }) =>
      request(`/platform-admin/usage?days=${days}`, { schema: usageSchema, signal }),
    enabled,
    ...base,
  });
}

export function useBusinesses(days: RangeDays, search: string, enabled: boolean) {
  return useQuery({
    queryKey: ['platform-admin', 'businesses', days, search],
    queryFn: ({ signal }) => {
      const qs = new URLSearchParams({ days: String(days) });
      if (search) qs.set('q', search);
      return request(`/platform-admin/businesses?${qs.toString()}`, {
        schema: businessesSchema,
        signal,
      });
    },
    enabled,
    ...base,
  });
}

export function useBusinessActivity(id: string | null, days: RangeDays) {
  return useQuery({
    queryKey: ['platform-admin', 'business', id, days],
    queryFn: ({ signal }) =>
      request(`/platform-admin/businesses/${encodeURIComponent(id!)}?days=${days}`, {
        schema: businessActivitySchema,
        signal,
      }),
    enabled: id !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
